import { useCallback, useMemo, useState } from 'react'

export const useLikeAnimation = () => {
  const [animations, setAnimation] = useState<number[]>([])

  const addAnimation = useCallback((key: number) => {
    /**
     * Добавляем только два блока анимации, больше не надо
     * Анимации, как бы следуют одна за другой
     */
    setAnimation((prev) => [key, ...(prev[0] ? [prev[0]] : [])])
  }, [])

  return useMemo(
    () => ({
      animations,
      addAnimation,
    }),
    [addAnimation, animations]
  )
}
